import modelAPI from '@/api/model.api.js';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
export default {
    namespaced: true,
    state: {
        isDark: false,
        isDebug: false,
        useLLM: 'PciTransGpt',
        modelList: [],
        curAssistant: {}
    },
    getters: {
        isPciTransGpt (state) {
            return state.useLLM === 'PciTransGpt';
        }
    },
    mutations: {
        setDark (state, val) {
            localStorage.setItem('isDark', val);
            state.isDark = val;
        },
        toggleDark (state) {
            let isDark = !state.isDark;
            localStorage.setItem('isDark', isDark);
            state.isDark = isDark;
        },
        retrieveDark (state) {
            state.isDark = localStorage.getItem('isDark') === 'true';
        },
        setDebug (state, val) {
            localStorage.setItem('isDebug', val);
            state.isDebug = val;
        },
        toggleDebug (state) {
            let isDebug = !state.isDebug;
            localStorage.setItem('isDebug', isDebug);
            state.isDebug = isDebug;
        },
        retrieveDebug (state) {
            state.isDebug = localStorage.getItem('isDebug') === 'true';
        },
        setLLM (state, val) {
            localStorage.setItem('useLLM', val);
            state.useLLM = val;
        },
        toggleLLM (state) {
            if (state.useLLM === 'PciTransGpt') state.useLLM = 'OpenAI';
            else state.useLLM = 'PciTransGpt';
            localStorage.setItem('useLLM', state.useLLM);
        },
        retrieveLLM (state) {
            let llm = localStorage.getItem('useLLM');
            if (llm) state.useLLM = llm;
            else state.useLLM = 'PciTransGpt';
        },
        setModelList (state, val) {
            localStorage.setItem('modelList', JSON.stringify(val));
            state.modelList = val;
        },
        changeModelSettings (state, val) {
            let newList = state.modelList;
            newList.forEach(item => {
                if (item.value === val.value) {
                    const { maxLength, contextLimit, temperature, topN } = val;
                    item.modelSettings = { maxLength, contextLimit, temperature, topN };
                }
            });
            localStorage.setItem('modelList', JSON.stringify(newList));
            state.modelList = newList;

            MODEL_LIST.forEach(item => {
                let one = newList.find((a) => {
                    return a.value === item.value;
                });
                if (one) {
                    item.modelSettings = one.modelSettings;
                }
            });
        },
        setCurrentAssistant (state, val) {
            state.curAssistant = val;
        }
    },

    actions: {

        async initModelList (context) {
            let modelList = require('@/app/constant/MODEL_LIST.js').default;
            // transGpt是demo测试版本，不走公服接口
            if (location.hash.indexOf('transGpt') === -1) {
                // 读取提示模板
                let ret = await modelAPI.getPromptTemplatePage({ pageSize: 999 });
                let promptTemplateAll = ret.data || [];
                modelList.forEach(item => {
                    let code = item.value;
                    let promptTemplate = promptTemplateAll.find(item => item.code === code);
                    if (promptTemplate) {
                        item.promptTemplate = promptTemplate;
                    }
                    let promptTemplateList = promptTemplateAll.filter(item => item.businessSystemCode === code);
                    if (promptTemplateList) {
                        item.promptTemplateList = promptTemplateList;
                    }
                });
            }

            let settings = localStorage.getItem('modelList');
            if (settings) {
                try {
                    settings = JSON.parse(settings);
                    modelList.forEach(item => {
                        let one = settings.find((a) => {
                            return a.value === item.value;
                        });
                        if (one) {
                            item.modelSettings = one.modelSettings;
                        }
                    });
                } catch (err) {
                    console.error(err);
                    localStorage.removeItem('modelList');
                }
            }
            // 缓存modelList
            context.commit('setModelList', modelList);
        }
    }
};
